import { Factory, trait } from 'miragejs';

export default Factory.extend({
  enabled: true,
  body: '',
  duration: 0,
  name: 'Meeting',
  optional: false,
  requiredResign: false,
  sendToBcc: false,
  sendToVisitor: true,

  withFlowAssign: trait({
    afterCreate(agreementPage, server) {
      const flow = server.schema.flows.findBy({ agreementPageId: null });

      flow?.update({
        agreementPage: agreementPage,
      });
    },
  }),
});
